import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/logo.svg'


const _hoisted_1 = { class: "flex" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "w-profile h-profile mr-s"
}, null, -1)
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }

import { ref } from "vue";
import { supabase } from "@/helpers/supabase";
import CenteredCard from "@/components/CenteredCard.vue";
import UmanaHeadline from "@/components/UmanaHeadline.vue";
import { greeting } from "@/helpers/greetinghelper";
import { useNotificationStore } from "@/store/notificationStore";
import { AuthError } from "@supabase/supabase-js";
import LabelButton from "@/components/LabelButton.vue";
import VersionDisplay from "@/components/VersionDisplay.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'AuthenticationView',
  setup(__props) {

const values = ref<any>({});
const sentOtp = ref<boolean>(false);
const register = ref(false);

const handleLogin = async (register: boolean) => {
  useNotificationStore().notifications = [];
  try {
    const { error } = await supabase.auth.signInWithOtp({
      email: values.value.email,
      options: {
        shouldCreateUser: register,
      },
    });

    if (error) throw error;
    useNotificationStore().notifications.push({
      msg: `Es wurde ein Bestätigungscode via E-Mail gesendet.`,
      type: "success",
    });
    window._paq.push(["trackEvent", "Login", "success - send mail"]);

    sentOtp.value = true;
    tries = 0;
    setTimeout(() => {
      document.getElementById("otp")?.focus();
    }, 0);
  } catch (error) {
    if (error instanceof AuthError) {
      if (error.status == 429) {
        useNotificationStore().notifications.push({
          msg: `Fehler - Aus Sicherheitsgründen können nur begrenzt E-Mails versendet werden. (#av00)`,
          type: "danger",
        });
        window._paq.push(["trackEvent", "Login", "fail - too many mails"]);
      } else if (!register) {
        useNotificationStore().notifications.push({
          msg: `Fehler - Diese E-Mail-Adresse ist nicht registriert (#av01)`,
          type: "danger",
        });
        window._paq.push(["trackEvent", "Login", "fail - mail not existing"]);
      } else {
        useNotificationStore().notifications.push({
          msg: `Fehler - Diese E-Mail-Adresse ist bereits registriert (#av02)`,
          type: "danger",
        });
        window._paq.push([
          "trackEvent",
          "Login",
          "fail - mail already registered or unknown",
        ]);
      }
    }
  }
};

let tries = 0;

const handleOtp = async () => {
  useNotificationStore().notifications = [];

  try {
    const { error } = await supabase.auth.verifyOtp({
      token: values.value.otp,
      email: values.value.email,
      type: "email",
    });
    if (error) throw error;
    window._paq.push(["trackEvent", "Login", "success - otp valid"]);
  } catch (error) {
    if (error instanceof Error) {
      tries++;
      if (tries > 5) {
        sentOtp.value = false;
        useNotificationStore().notifications.push({
          msg: `Fehler: zu viele falsche Codes eingetippt. Loggen Sie sich erneut ein. (#at04)`,
          type: "danger",
        });
        window._paq.push(["trackEvent", "Login", "fail - OTP failed to often"]);
      } else {
        useNotificationStore().notifications.push({
          msg: `Fehler: Code ungültig oder abgelaufen (#at03)`,
          type: "danger",
        });
        window._paq.push(["trackEvent", "Login", "fail - OTP invalid"]);
      }
    }
  }
};

return (_ctx: any,_cache: any) => {
  const _component_FormKit = _resolveComponent("FormKit")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(CenteredCard, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _hoisted_2,
          _createVNode(UmanaHeadline, { h: "h1" }, {
            default: _withCtx(() => [
              _createTextVNode("mediBe")
            ]),
            _: 1
          })
        ]),
        _createVNode(UmanaHeadline, {
          h: "h2",
          class: "mb-s"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(greeting)()), 1)
          ]),
          _: 1
        }),
        (!sentOtp.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              (!register.value)
                ? (_openBlock(), _createBlock(_component_FormKit, {
                    key: 0,
                    type: "form",
                    name: "loginForm",
                    "submit-label": "Login",
                    onSubmit: _cache[0] || (_cache[0] = ($event: any) => (handleLogin(false))),
                    actions: false,
                    modelValue: values.value,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((values).value = $event))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_FormKit, {
                        type: "email",
                        name: "email",
                        label: "E-Mail",
                        autofocus: "",
                        placeholder: "mara@muster.ch",
                        validation: "required|email"
                      }),
                      _createVNode(_component_FormKit, {
                        type: "submit",
                        label: "Login"
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue"]))
                : (_openBlock(), _createBlock(_component_FormKit, {
                    key: 1,
                    type: "form",
                    "submit-label": "Registrieren",
                    autofocus: "",
                    onSubmit: _cache[2] || (_cache[2] = ($event: any) => (handleLogin(true))),
                    modelValue: values.value,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((values).value = $event))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_FormKit, {
                        type: "email",
                        name: "email",
                        label: "E-Mail",
                        placeholder: "max@muster.ch",
                        help: "Wählen Sie, wenn möglich, eine Geschäfts-E-Mail-Adresse",
                        validation: "required|email"
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue"]))
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createVNode(_component_FormKit, {
                type: "form",
                "submit-label": "Login",
                onSubmit: handleOtp,
                actions: false,
                modelValue: values.value,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((values).value = $event))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_FormKit, {
                    type: "text",
                    name: "otp",
                    label: "Bestätigungscode",
                    placeholder: "000000",
                    autofocus: "",
                    id: "otp",
                    validation: "required|length:6,6"
                  }),
                  _createVNode(_component_FormKit, {
                    type: "submit",
                    label: "Login"
                  })
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(LabelButton, {
                onClick: _cache[5] || (_cache[5] = ($event: any) => (sentOtp.value = false)),
                label: "Mit einer anderen E-Mail-Adresse anmelden"
              })
            ])),
        _createVNode(VersionDisplay)
      ]),
      _: 1
    })
  ]))
}
}

})